import { React, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getClass,
  getStudents,
  getQR,
  createSpecialEdStudent,
} from "../services/APIClient";

import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import ClassOverview from "../components/ClassOverview";
import ClassAccessDeniedAlert from "../components/ClassAccessDeniedAlert";
import OrientationPrompt from "../components/OrientationPrompt";
import { Alert, Container, Row, Col } from "react-bootstrap";
import "../components/ClassOverview.css";

function ClassDetail(props) {
  const location = useLocation();
  const [isFromAddStudents, setIsFromAddStudents] = useState(false);
  const [isFromClassSelection, setIsFromClassSelection] = useState(false);

  let classDetails = location.state.classDetails.classDetails;
  let name = location.state.name.name || location.state.name.newClassName;
  let teachers = location.state.teachers.teachers;
  let gradeLevel = location.state.gradeLevel.gradeLevel;
  let rollNumber = location.state?.rollNumber?.rollNumber;
  let teacherEmail = location.state?.teacherEmail?.teacherEmail;
  let classid = location.state.classDetails.classDetails.id;
  let teacherid = location.state.teacherid?.teacherid;
  let teacherName = location.state.teacherName?.teacherName;
  let schoolid = location.state?.schoolid.schoolid;
  let isSpecialEdClass = classDetails.specialed_class;
  let teacherRoles = location.state?.teacherRoles?.teacherRoles;
  let isAccessRestricted = location.state?.isAccessRestricted?.isAccessRestricted;
  let isPilot = location.state?.isPilot?.isPilot;
  let fromClassDetailsSpecial = location.state?.fromClassDetailsSpecial;

  // let fromClassDetailsSpecial = true;

  console.log(teacherid, "TEACHER ID IN CLASS DETAIL");
  console.log(teacherName, "teacherName IN CLASS DETAIL");

  console.log(location.state, "LOCATION STATE IN CLASS DETAIL");

  const [group, setGroup] = useState("");
  const [studentsResponse, setStudentsResponse] = useState("");
  const [qrCodeDetails, setQRCodeDetails] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    // Check if we came from the /addstudents page using the state flag
    if (location.state && location.state.fromAddStudents) {
      setIsFromAddStudents(true);
    }
    
    // Check if we came from the class selection modal in ClassAdminDashboard
    if (location.state && location.state.fromClassSelection) {
      setIsFromClassSelection(true);
    }

    if (fromClassDetailsSpecial) {
      setIsFromClassSelection(true);
    }


    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, [location.state]);

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setLoadError(null);

    Promise.all([getClass(classid), getStudents(classid), getQR(classid)])
      .then(([classResponse, studentResponse, qrResponse]) => {
        if (cancelled) return;
        setGroup(classResponse);
        setStudentsResponse(studentResponse);
        setQRCodeDetails(qrResponse);
        setLoading(false);
      })
      .catch((error) => {
        if (cancelled) return;
        const status = error?.response?.status;
        setLoadError(status === 403 || status === 404 ? "forbidden" : "error");
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [classid, location.key]);

  useEffect(() => {
    // Check if all data is loaded before setting loading to false
    if (group && studentsResponse && qrCodeDetails) {
      // Conditionally trigger API call based on state
      if (isSpecialEdClass && studentsResponse.students && isFromAddStudents) {
        // Transform student data into the required format and wrap in an array
        const formattedStudents = studentsResponse.students
          .filter((student) => student.currentGrade || student.countryGradeId) // Filter out students without necessary data
          .map((student) => ({
            studentId: student.id,
            countrygradeId: student.countryGradeId || "Unknown", // Default value if not provided
            currentGrade: student.currentGrade || "Unknown", // Default value if not provided
            dateadded: new Date().toISOString(), // Current date in ISO format
          }));

        // Make API call with array data
        createSpecialEdStudent(formattedStudents)
          .then((data) => {})
          .catch((error) => {
            console.error(
              "Error creating SpecialEdStudents:",
              error.response ? error.response.data : error.message
            );
          });
      }
    }
  }, [
    group,
    studentsResponse,
    qrCodeDetails,
    isSpecialEdClass,
    isFromAddStudents,
  ]);

  let students = [
    ...(studentsResponse.students || []),
    ...(studentsResponse.additionalStudents || []),
  ];

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={name}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          {loading ? (
            <div className="spinner-container">
              <div className="big-ball-spinner"></div>
            </div>
          ) : loadError === "forbidden" ? (
            <ClassAccessDeniedAlert />
          ) : loadError ? (
            <Alert variant="danger" role="alert" className="m-4">
              We couldn’t load this classroom. Please refresh the page and try again.
            </Alert>
          ) : (
            <ClassOverview
              group={group}
              classDetails={classDetails}
              teachers={teachers}
              sharedWith={group.sharedWith}
              students={students}
              gradeLevel={gradeLevel}
              name={name}
              qrCodeDetails={qrCodeDetails}
              rollNumber={rollNumber}
              teacherEmail={teacherEmail}
              schoolid={schoolid}
              isSpecialEdClass={isSpecialEdClass}
              teacherRoles={teacherRoles}
              teacherid={teacherid}
              teacherName={teacherName}
              isAccessRestricted={isAccessRestricted}
              isPilot={isPilot}
              isFromClassSelection={isFromClassSelection}
              fromClassDetailsSpecial={fromClassDetailsSpecial}
            />
          )}
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default ClassDetail;
